import React from "react";
import {
    getInsetTop,
    calc,
    chipsAppCode,
} from "../js/chips-common.js";
import ChipsPopup from "../component/chips-popup";
import chipsWebApi
    from "../js/chips-web-api";
import "../assets/Common.scss";
import "../assets/fonts/font.css";

const POPUP_ENUM = {
    WITHDRAW_WAIT: "WITHDRAW_WAIT",
    WITHDRAW_REQUEST: "WITHDRAW_REQUEST",
    WITHDRAW_CONFIRM: "WITHDRAW_CONFIRM",
    WITHDRAW_COMPLETED: "WITHDRAW_COMPLETED",
    WITHDRAW_CANCEL: "WITHDRAW_FAIL",
};

export default function Withdraw(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";
    const endPoint = window.location.origin;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const accessToken = urlParams.get("accessToken");
    const refreshToken = urlParams.get("refreshToken");

    const isLoggedIn:Boolean = () => {
        return accessToken !== null && refreshToken !== null;
    }

    const [popUpSelection, setPopUpSelection] = React.useState(POPUP_ENUM.WITHDRAW_WAIT);

  function goToLoginPage() {
        window.location.href = "/user/login"
  }

  function requestWithdraw() {
      if (!accessToken || !refreshToken) {
          setPopUpSelection(POPUP_ENUM.WITHDRAW_CANCEL);
          alert("탈퇴에 실패했습니다.")
          goToLoginPage();
          return;
      }
      chipsWebApi.request({
          method: "post",
          url: `${domain}/api/v1/auth/withdraw`,
          headers: {
              "Content-Type": "application/json",
              "x-nbt-access-token": `${accessToken}`,
              "x-nbt-refresh-token": `${refreshToken}`,
              "x-nbt-app-code": chipsAppCode,
          },
          then: (response) => {
              if (response.status === 200) {
                  setPopUpSelection(POPUP_ENUM.WITHDRAW_COMPLETED);
              } else {
                  setPopUpSelection(POPUP_ENUM.WITHDRAW_CANCEL);
                  alert("탈퇴에 실패했습니다.")
                  goToLoginPage();
              }
          },
          catch: (error, attributes) => {
              setPopUpSelection(POPUP_ENUM.WITHDRAW_CANCEL);
              alert(attributes.message || "탈퇴에 실패했습니다.");
          },});
  }

  return (
    <div
      style={{
        background: "#FFF",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />
        {popUpSelection === POPUP_ENUM.WITHDRAW_REQUEST || popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED ?
      <ChipsPopup
        attributes={{
            title: popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED ?  "탈퇴가 완료되었습니다." : "정말 탈퇴하시겠어요?",
            description:popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED ?  <>보다 나은 서비스로<br/>다시 만나뵐 수 있기를 바랍니다.</> : "보유한 혜택이 모두 사라집니다.",
            cancelButtonTitle:popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED ?  null : "아니요",
            confirmButtonTitle: popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED ?  "확인" : "탈퇴하기",
            completion: (result:Boolean) => {
                if (popUpSelection === POPUP_ENUM.WITHDRAW_COMPLETED && result === true) {
                    window.location.href = `${endPoint}/user/login`;
                } else {
                    if (result === true) {
                        requestWithdraw();
                    }
                    setPopUpSelection(result ? POPUP_ENUM.WITHDRAW_CONFIRM : POPUP_ENUM.WITHDRAW_WAIT);
                }
          },
        }}
      />
      : null}
      <div
        className="scrollbar-hidden"
        style={{
          position: "relative",
          bottom: 0,
          top: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            position: "relative",
            top: getInsetTop(),
            width: calc(360),
            zIndex: 1,
          }}
        >
          <div
            style={{
              margin: `${calc(16)} ${calc(0)}`,
              justify: "center",
              width: "100vw",
              alignItems: "center",
              fontSize: calc(20),
              fontWeight: 900,
              fontFamily: "Spoqa Hans Sans Neo",
              lineHeight: calc(30),
            }}
          >
            탈퇴하기
          </div>
        </div>

        <div
          style={{
            position: "relative",
            top: calc(0),
            width: "100vw",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",

          }}
        >
          <div
            style={{
              textAlign: "left",
              margin: `${calc(20)} ${calc(20)} ${calc(0)} ${calc(20)}`,
              fontSize: calc(20),
              lineHeight: calc(30),
              fontWeight: 900,
              font: "Spoqa Hans Sans Neo",
              color: "#212121",
            }}
          >
            정말 떠나시나요?
            <br />
            보유한 혜택이 모두 사라집니다.
          </div>
          <div
            style={{
              textAlign: "left",
              margin: `${calc(20)} ${calc(20)} ${calc(0)} ${calc(20)}`,
              fontSize: calc(14),
              lineHeight: calc(20),
              font: "Spoqa Hans Sans Neo",
              color: "#212121",
            }}
          >
            지금 탈퇴하면 보유한 칩스 포인트는 모두 소멸되며, 14일 이내 재가입이
            불가합니다.
          </div>
          <div
            style={{
              textAlign: "left",
              margin: `${calc(20)} ${calc(20)} ${calc(0)} ${calc(20)}`,
              fontSize: calc(14),
              fontWeight: 700,
              font: "Spoqa Hans Sans Neo",
              color: "#212121",
            }}
          >
            회원 탈퇴 유의사항
          </div>
          <div
            style={{
              textAlign: "left",
              margin: `${calc(0)} ${calc(24)} ${calc(0)} ${calc(24)}`,
            }}
          >
            <ul
              style={{
                textAlign: "left",
                gap: calc(8),
                fontSize: calc(12),
                color: "#9E9E9E",
                font: "Spoqa Hans Sans Neo",
              }}
            >
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                회원 탈퇴 시 보유하고 있던 칩스 포인트는 모두 소멸되며, 이전으로
                복구가 불가능합니다.
              </li>
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                회원 탈퇴 시 회원 정보 및 서비스 이용 기록은 모두 삭제되며,
                삭제된 데이터는 복구가 불가능합니다. 다만 법령 또는 내부 방침에
                따라 보존해야 하는 경우 일정 기간 보관 후 파기됩니다. 자세한
                사항은 칩스 개인정보 처리방침에서 확인할 수 있습니다.
              </li>
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                회원 탈퇴 후 14일 이내에 동일한 계정과 휴대폰 번호로 재가입이
                불가합니다.
              </li>
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                회원 탈퇴 이후 재가입하더라도 탈퇴 이전의 회원 정보, 거래 정보
                및 칩스 포인트 등은 복구되지 않습니다.
              </li>
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                의도적인 탈퇴와 재가입이 확인되는 경우, 향후 서비스 가입 및 혜택
                제공에 제한이 따를 수 있습니다.
              </li>
              <li
                style={{
                  margin: `${calc(10)} 0 0 0`,
                }}
              >
                회원 탈퇴 이후에는 고객센터 대응에 어려움이 있을 수 있습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div
          className="active-only-alpha"
          style={{
            position: "absolute",
            backgroundColor: "#7CFC00",
            width: "100vw",
            bottom: 0,
            height: calc(50),
            alignItems: "center",
            justifyContent: "center",
            font: "Spoqa Hans Sans Neo",
            fontSize: calc(16),
            lineHeight: calc(20),
              pointerEvents: `${popUpSelection === POPUP_ENUM.WITHDRAW_WAIT ? "auto" : "none"}`,
              opacity: popUpSelection === POPUP_ENUM.WITHDRAW_WAIT ? 1 : 0.4,
          }}
          onClick={() => {
              if (isLoggedIn()) {
                  setPopUpSelection(POPUP_ENUM.WITHDRAW_REQUEST);
              } else {
                  goToLoginPage()
              }
          }}
        >
          회원 탈퇴하기
        </div>
      </div>
    </div>
  );
}